module.exports = __webpack_public_path__ + "static/media/up.f6a42523.svg";